(() => {
  const canonicalViewport = 'width=device-width,initial-scale=1';
  const viewport = document.querySelector('meta[name="viewport"]');

  if (!viewport) return;

  const restoreViewport = () => {
    if (viewport.getAttribute('content') !== canonicalViewport) {
      viewport.setAttribute('content', canonicalViewport);
    }
  };

  restoreViewport();

  const observer = new MutationObserver(restoreViewport);
  observer.observe(viewport, { attributes: true, attributeFilter: ['content'] });
})();
